import { required, email, requiredIf,integer } from 'vuelidate/lib/validators'
import { fileSize, vatid, zip, date,  minDate,
  maxDate
 } from '@/ic-common/helpers/validation'
import { isCompany, isImienna, isInnyAdres } from './helpers'
import moment from 'moment'

export default {
  form: {
    company: {
      company: { requiredIf: requiredIf(isCompany) },
      vatid: { requiredIf: requiredIf(isCompany), vatid },
    },
    address:{
      street: { required },
      streetNo: { required },
      zip: { required, zip },
      city: { required }
    },
    
    post_street: { requiredIf: requiredIf(isInnyAdres) },
    post_street_no: { requiredIf: requiredIf(isInnyAdres) },
    post_zip: { requiredIf: requiredIf(isInnyAdres), zip },
    post_city: { requiredIf: requiredIf(isInnyAdres) },
    
    person: {
      name: { required },
      phone: { required },
      email: { required,email},
    },
    card:{
      date_from: {
          required,
          maxDate: maxDate(moment().add(3,"M").format('YYYY-MM-DD')),
          minDate: minDate(moment().add(1,"day").format('YYYY-MM-DD'))
        },
      owner_document: {},
      owner: {requiredIf: requiredIf(isImienna)}
    },

    regulamin: {
      required
    },
    akceptacja_dane: {
      required
    }
  }
}
